import styled from "styled-components";

export const Container = styled.div`
  max-height: 330px;
  padding: 30px 40px 40px 40px;
  overflow: auto;

  .titleStorage {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    padding-bottom: 7px;
  }

  .titleServiceList {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    padding: 7px 0 3px 0;
  }

  .serviceContainer {
    display: flex;
    padding-left: 32px;
    margin: 5px 0 0 0;
    align-items: center;
    user-select: none;
    cursor: pointer;

    &.active {
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.primary.primaryContainer}, ${theme.colors.surface.surface})`} !important;

      .selectedIcon {
        color: ${({ theme }) => theme.colors.primary.primary} !important;
      }

      .titleService {
        color: ${({ theme }) => theme.colors.primary.primary} !important;
      }
    }

    .iconService {
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder} !important;
    }
    
    .iconServiceActive {
      color: ${({ theme }) => theme.colors.primary.primary} !important;
    }
  }

  .titleService {
    width: 80px;
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    margin-left: 20px;
  }

  .emailService {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    padding-left: 20px;
  }

  .selectedIcon {
    margin-right: 34px !important;
  }

  .unselectedIcon {
    height: 15px;
    width: 15px;
    border-radius: 20px;
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    margin-right: 39px;
    margin-left: 4px;
  }
`;
